import React, { ReactElement } from 'react';

import { ICON_COLOR, ICON_TYPE, OzIcon } from '../icon/Icon';
import { ICON_SIZE } from '../icon/ICON_SIZE';

import { IModalContextValue, useModalContext } from './ModalContext';

export function OzModalCloseButton (): ReactElement {
    const { hideModal }: IModalContextValue = useModalContext();

    return (
        <button
            className="flex grow shrink-0 justify-end h-2"
            onClick={hideModal}
            aria-label="Close Modal"
        >
            <OzIcon
                alt="Close"
                color={ICON_COLOR.DARK}
                size={ICON_SIZE.MEDIUM}
                type={ICON_TYPE.OZ_CLOSE}
                className="h-2 w-2 float-right hover:cursor-pointer"
            />
        </button>
    );
}
